import { message } from "antd";
import * as api from "../api";
import {
  FETCHALLSHIPPINGS,
  CREATESHIIPING,
  FETCHSHIIPING,
  DELETESHIPPING,
  UPDATESHIIPING,
} from "../constants/actionTypes";

export const createShipping =
  (formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createShipping(formData);
      dispatch({ type: CREATESHIIPING, data });
      if (data) {
        setLoadingButton(false);
        history("/store")
        message.success("Shipping added successfully");
      }
    } catch (error) {
      if (error) {
        console.log(error);
        setLoadingButton(false);
        message.error(error);
      }
    }
  };

// export const getShippings = (storeId) => async (dispatch) => {
//   try {
//     const { data } = await api.getShippings(storeId);
//     dispatch({ type: FETCHALLSHIPPINGS, payload: data });
//   } catch (error) {
//     console.log(error);
//   }
// };

export const getShipping = (id) => async (dispatch) => {
  try {
    const { data } = await api.getShipping(id);
    dispatch({ type: FETCHSHIIPING, payload: data });
  } catch (error) {
    console.log(error);
  }
};

export const deleteShipping = (id, history) => async (dispatch) => {
  try {
    const response = await api.deleteShipping(id);
    dispatch({ type: DELETESHIPPING, payload: id });
    if (response) {
      history("/store");
      message.success("Shipping deleted successfully");
    }
  } catch (error) {
    console.log(error?.response?.data?.message);
    message.error(error?.response?.data?.message);
  }
};

export const updateShipping =
  (id, formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateShipping(id, formData);
      dispatch({ type: UPDATESHIIPING, payload: data });
      if (data) {
        history("/store");
        setLoadingButton(false);
      }
    } catch (error) {
      console.log(error);
      setLoadingButton(false);
    }
  };